import { api, ApiRes } from './_api-client';

export enum UserStatus {
  Pending,
  Accepted,
  Rejected,
}

export enum UserRole {
  Owner,
  Support,
  Editor,
  Reader,
}

export interface Collaborator {
  userId: number;
  role: number;
  status: number;
  userName: string;
  email: string;
  fullName: string;
}

export interface RemoveCollaborator {
  projectId: ProjectId;
  userId: number;
}

export interface ShareProject {
  query: string;
  role: UserRole;
}

export const shareProjectToSupport = (projectId: ProjectId) => {
  return api.post<ApiRes>(`/Share/ShareProjectToSupport`, { projectId });
};

export const shareProject = (payload: ShareProject) => {
  return api.post<ApiRes>(`/Share/ShareProject?query=${payload.query}&role=${payload.role}`);
};

export const removeCollaborator = (payload: RemoveCollaborator) => {
  return api.delete<ApiRes>(`/Share/RemoveCollaborator?projectId=${payload.projectId}&userId=${payload.userId}`);
};

export const getCollaborators = (projectId: ProjectId) => {
  return api.get<Collaborator[]>(`/Share/GetCollaborators?projectId=${projectId}`);
};
